<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-folder-open" titulo="CADASTRO DE GRUPO DE CONTAS A RECEBER">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{registro.CODIGO || 'Novo'}}</strong>
            </span>
            <span v-if="registro.DESCRICAO" class="mx-2">•</span>
            <span v-if="registro.DESCRICAO" class="mr-2">
              {{registro.DESCRICAO.substring(0,50)}}
            </span>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="gravar()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Dados Principais -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-info-circle"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações Principais</h6>
                  <small class="text-muted">Dados do grupo de contas a receber</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="8">
                <label class="modal-label-premium">Descrição *</label>
                <b-form-input 
                  type="text" 
                  v-model="registro.DESCRICAO" 
                  maxlength="70" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !registro.DESCRICAO}"
                  placeholder="Informe a descrição do grupo"
                  ref="edDescricao">
                </b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Situação *</label>
                <b-form-select 
                  v-model="registro.OP_SITUACAO" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !registro.OP_SITUACAO}">
                  <b-form-select-option value="1">Ativo</b-form-select-option>
                  <b-form-select-option value="0">Inativo</b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>
          </b-card>

          <!-- Observações -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-comment"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Observações</h6>
                  <small class="text-muted">Informações adicionais</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="12" class="mb-3">
                <label class="modal-label-premium">Observação</label>
                <b-form-textarea 
                  v-model="registro.OBS" 
                  rows="4"
                  maxlength="1000"
                  class="rounded shadow-xs"
                  placeholder="Informe observações adicionais (opcional)">
                </b-form-textarea>
              </b-col>
            </b-row>
          </b-card>

          <!-- Informações de Auditoria -->
          <b-card v-if="registro.CODIGO" class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-history"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações de Auditoria</h6>
                  <small class="text-muted">Dados de cadastro e alteração</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Usuário Cadastro</label>
                <b-form-input 
                  type="text" 
                  :value="registro.USUARIO_CADASTRO" 
                  disabled 
                  class="rounded-pill shadow-xs bg-light campo-desabilitado">
                </b-form-input>
              </b-col>
              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Data Cadastro</label>
                <b-form-input 
                  type="text" 
                  :value="formatarDataBR(registro.DT_CADASTRO)" 
                  disabled 
                  class="rounded-pill shadow-xs bg-light campo-desabilitado">
                </b-form-input>
              </b-col>
              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Usuário Alteração</label>
                <b-form-input 
                  type="text" 
                  :value="registro.USUARIO_ALTERACAO || '-'" 
                  disabled 
                  class="rounded-pill shadow-xs bg-light campo-desabilitado">
                </b-form-input>
              </b-col>
              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Data Alteração</label>
                <b-form-input 
                  type="text" 
                  :value="formatarDataBR(registro.DT_ALTERACAO)" 
                  disabled 
                  class="rounded-pill shadow-xs bg-light campo-desabilitado">
                </b-form-input>
              </b-col>
            </b-row>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'

export default {
  components: {
    HeaderPadrao
  },
  data() {
    return {
      registro: {
        CODIGO: null,
        DESCRICAO: '',
        OBS: '',
        OP_SITUACAO: '1',
        USUARIO_CADASTRO: '',
        USUARIO_ALTERACAO: '',
        DT_CADASTRO: null,
        DT_ALTERACAO: null
      }
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] }
  },

  methods: {
    voltar() {
      this.$router.push('/cadastros/grupo-areceber')
    },

    getUsuarioLogado() {
      return window.localStorage.getItem('login') || 'Sistema'
    },
    
    async carregar(id) {
       this.$store.commit('controle/setAguardando', true)
       try {
           const response = await this.$http.get(`/api/protected/grupo-areceber/getById/${id}`)
           
           if (Array.isArray(response.data) && response.data.length > 0) {
              const item = response.data[0]
              this.registro = { ...this.registro, ...item }
           } else {
               this.$bvToast.toast('Registro não encontrado', { variant: 'warning' })
               this.voltar()
           }

       } catch (err) {
           console.error('Erro ao carregar', err)
           this.$bvToast.toast('Erro ao carregar dados', { variant: 'danger' })
       } finally {
            this.$store.commit('controle/setAguardando', false)
       }
    },

    async gravar() {
        // Validações
        if (!this.registro.DESCRICAO || this.registro.DESCRICAO.trim() === '') {
            this.$bvToast.toast('Informe a Descrição', { variant: 'warning' })
            if (this.$refs.edDescricao) {
              this.$refs.edDescricao.focus()
            }
            return
        }

        if (!this.registro.OP_SITUACAO) {
            this.$bvToast.toast('Informe a Situação', { variant: 'warning' })
            return
        }

        try {
            const body = {
                registro: {
                  ...this.registro
                },
                login: window.localStorage.getItem('login') || 'sistema'
            }
            
            const isNovo = !this.registro.CODIGO
            let url = '/api/protected/grupo-areceber/post'
            if (!isNovo) {
                url = '/api/protected/grupo-areceber/edit'
            }

            const res = await this.$http.post(url, body)

            // Captura o ID do registro salvo para selecionar na listagem
            let idSalvo = null
            
            if (isNovo) {
              // Para novos registros, tenta múltiplas possibilidades
              idSalvo = res.data?.CODIGO || 
                       res.data?.codigo || 
                       res.data?.insertId || 
                       res.data?.registro?.CODIGO ||
                       res.data?.registro?.codigo ||
                       null
            } else {
              idSalvo = this.registro.CODIGO
            }
            
            if (idSalvo) {
              this.$store.commit('grupoAreceber/SET_REGISTRO_SELECIONADO_ID', idSalvo)
            }
            this.$store.commit('grupoAreceber/SET_RECARREGAR_LISTA', true)

            this.$bvToast.toast('Registro salvo com sucesso', { variant: 'success' })
            this.voltar()

        } catch (err) {
             console.error('Erro ao gravar', err)
             this.$bvToast.toast('Erro ao salvar registro', { variant: 'danger' })
        }
    },

    formatarDataBR(data) {
      if (!data) return '-'
      const d = new Date(data)
      if (isNaN(d)) return '-'
      const dia = String(d.getDate()).padStart(2, '0')
      const mes = String(d.getMonth() + 1).padStart(2, '0')
      const ano = d.getFullYear()
      return `${dia}/${mes}/${ano}`
    }
  },
  
  async created() {
      const id = this.$route.params.id
      if (id) {
          await this.carregar(id)
      }
  },
  
  mounted() {
      this.$nextTick(() => {
          // Focus no campo de descrição
          if (this.$refs.edDescricao && !this.registro.CODIGO) {
            this.$refs.edDescricao.focus()
          }
      })
  }

}
</script>

<style scoped>
.campo-desabilitado {
  background-color: #e9ecef !important;
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}

.modal-label-premium {
    font-size: 0.8rem;
    font-weight: 700;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/grupo/GrupoAreceberCadastro.vue